module.exports = __webpack_public_path__ + "img/product-bg2.d47f4a85.png";